/**
 * ตัวช่วยเกี่ยวกับประเภทสมาชิก VAT
 * สมาชิกแบบตลอดชีพไม่มีวันหมดอายุ จึงต้องแสดงคำว่า "ตลอดชีพ" แทนวันที่
 */

/** คำที่ใช้เรียกสมาชิกแบบตลอดชีพ */
export const LIFETIME_MEMBER_LABEL = 'ตลอดชีพ';

/**
 * ตรวจสอบว่าเป็นสมาชิกแบบตลอดชีพหรือไม่
 * รองรับทั้งค่า 'ตลอดชีพ' และค่าที่มีวงเล็บต่อท้าย เช่น 'ตลอดชีพ(ค่าธรรมเนียม 5,000 บาทตลอดชีพ)'
 */
export function isLifetimeMemberType(vatType?: string | null): boolean {
  return !!vatType && vatType.includes(LIFETIME_MEMBER_LABEL);
}

/**
 * ข้อความวันหมดอายุบัตรสมาชิก
 * - ตลอดชีพ: แสดงคำว่า "ตลอดชีพ"
 * - รายปี: แสดงวันที่ตามรูปแบบที่ component ใช้อยู่
 */
export function formatMemberExpiry(
  vatType: string | null | undefined,
  vatExpired: string | null | undefined,
  formatDate: (value: string) => string
): string {
  if (isLifetimeMemberType(vatType)) {
    return LIFETIME_MEMBER_LABEL;
  }

  return vatExpired ? formatDate(vatExpired) : '-';
}
